var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarmReminderBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgb(138, 193, 252)",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "rgb(138, 193, 252)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3,7.5a7.45,7.45,0,0,0-6.2-5.9,7.81,7.81,0,0,0-5.8,1.6.81.81,0,0,0,.2,1.4,28.48,28.48,0,0,1,9.4,8.2.84.84,0,0,0,1.4,0A6.87,6.87,0,0,0,50.3,7.5ZM13.5,4.7a.9.9,0,0,0,.2-1.4A7,7,0,0,0,7.9,1.7,7.23,7.23,0,0,0,1.7,7.5a7.36,7.36,0,0,0,1.1,5.3.84.84,0,0,0,1.4,0A26,26,0,0,1,13.5,4.7ZM26,6.5a22.06,22.06,0,0,0-22,22,21.58,21.58,0,0,0,4.3,13L5,44.8a3.2,3.2,0,0,0,0,4.6,3.15,3.15,0,0,0,4.6,0l3.3-3.3A22.1,22.1,0,0,0,26,50.4a21.58,21.58,0,0,0,13-4.3l3.3,3.3a3.25,3.25,0,0,0,2.4,1A3.3,3.3,0,0,0,47,44.8l-3.3-3.3a21.58,21.58,0,0,0,4.3-13A21.94,21.94,0,0,0,26,6.5ZM10.5,28.4A15.5,15.5,0,1,1,26,43.9,15.49,15.49,0,0,1,10.5,28.4Zm18-.9V21.1a2.37,2.37,0,0,0-2.4-2.4,2.43,2.43,0,0,0-2.4,2.4v7.3a2.06,2.06,0,0,0,.7,1.7l5.7,5.7a2.41,2.41,0,0,0,3.4,0,2.3,2.3,0,0,0,0-3.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmReminderBlack);
export default __webpack_public_path__ + "static/media/AlarmReminderBlack.6ed2c041dda7622c23d1c634bcec4a02.svg";
export { ForwardRef as ReactComponent };